module.exports = __webpack_public_path__ + "img/review-link-generator.42dde51f.png";